document.addEventListener('DOMContentLoaded', function() {
    var checkoutButton = document.querySelector('.cart__checkout');
    
    if (checkoutButton) {
        checkoutButton.addEventListener('click', function() {
            localStorage.setItem('fromCheckout', 'true');
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    // Check if the user came from the checkout page
    if (localStorage.getItem('fromCheckout') === 'true') {
        // Remove the flag
        localStorage.removeItem('fromCheckout');
        // Reload the page
        window.location.reload();
    }
});
